import React from "react";
import { AlertCardDataRequired } from "../components/AlertCardDataRequired";
import { AlertDataRequiredInputs } from "../components/AlertDataRequiredInputs";

function SettingChampionship({
	register,
	valueAllowLeagueBets,
	errors,
	alertRequiredDataDescription,
}) {
	if (!valueAllowLeagueBets) {
		return null;
	}

	return (
		<div className='group-form-settings-card'>
			<h3 className='group-form-settings-title'>
				Configuracion de apuestas de campeonato
			</h3>
			<p className='group-form-settings-copy'>
				Completa estos datos para cerrar los picks especiales antes del torneo.
			</p>

			<div className='group-form-grid'>
				<div>
					<label htmlFor='startDate' className='form-label'>
						Fecha limite para apostar
					</label>
					<input
						id='startDate'
						className='form-control group-form-input'
						type='date'
						{...register("selectLimitedDateToChampionship", {
							required: valueAllowLeagueBets ? true : false,
						})}
					/>
					{errors.selectLimitedDateToChampionship?.type === "required" && (
						<AlertDataRequiredInputs>
							{alertRequiredDataDescription.settingDate}
						</AlertDataRequiredInputs>
					)}
				</div>

				<div>
					<label htmlFor='championBetPoints' className='form-label'>
						Puntos para el campeon
					</label>
					<input
						type='number'
						className='form-control group-form-input'
						id='championBetPoints'
						{...register("championBetPoints", {
							required: valueAllowLeagueBets ? true : false,
						})}
					/>
					{errors.championBetPoints?.type === "required" && (
						<AlertDataRequiredInputs>
							{alertRequiredDataDescription.settingPointChampion}
						</AlertDataRequiredInputs>
					)}
				</div>
			</div>

			<div className='mt-3'>
				<label htmlFor='runnerUpBetPoints' className='form-label'>
					Puntos para el subcampeon
				</label>
				<input
					type='number'
					className='form-control group-form-input'
					id='runnerUpBetPoints'
					{...register("runnerUpBetPoints", {
						required: valueAllowLeagueBets ? true : false,
					})}
				/>
				{errors.runnerUpBetPoints?.type === "required" && (
					<AlertDataRequiredInputs>
						{alertRequiredDataDescription.settingPointSubchampion}
					</AlertDataRequiredInputs>
				)}
			</div>

			{errors.runnerUpBetPoints?.type === "required" && (
				<AlertCardDataRequired>
					{alertRequiredDataDescription.createGroupWithSetting}
				</AlertCardDataRequired>
			)}
		</div>
	);
}

export { SettingChampionship };
